import styled from 'styled-components';

const Users = styled.div``;

const TableHeader = styled.div`
  align-items: center;
  display: flex;
  height: 32px;
  margin-bottom: 8px;
`;

const TableHeaderTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const TableHeaderTitleText = styled.p``;

export { TableHeader, TableHeaderTitle, TableHeaderTitleText, Users };
